// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coustomBg {
  background: #c4c4c4;
  height: 737px;
  clip-path: circle(180vh at 50% -80vh);
  position: relative;
}
.imageContainer {
  position: absolute;
  right: 0%;
  bottom: 0;
  width: 35%;
}
.heroWomanImage {
  width: 80%;
}
@media only screen and (max-width: 767.98px) {
  /* For screens smaller than medium (up to 767.98px) */
  .coustomBg {
    height: 500px;
    border-bottom-left-radius: 140px 100px;
    position: relative;
    overflow: hidden;
    padding-top: 24px;
  }
}

.bookingBackgroundCoustom {
  width: 213px;
  height: 31px;
  background-color: white;
  line-height: 33px;
  margin-top: 80px;
}
@media only screen and (max-width: 767.98px) {
  .imageContainer {
    position: absolute;
    width: 60%;
    left: 42%;
    bottom: 0;
    transform: scaleX(1) !important;
  }
  /* For screens smaller than medium (up to 767.98px) */
  .heroWomanImage {
    width: 100%;
    height: auto;
  }
  .bookingBackgroundCoustom {
    width: 200px;
    height: 30.706px;
    color: #fff;
    font-family: "Roboto";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 33px;
    margin-top: 20px;
  }
}
.bookingText {
  color: #5b7cfd;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  margin-left: 5px;
}
.clindexHeroHeading {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 50px;
  color: #ffffff;
}
@media only screen and (max-width: 767.98px) {
  .clindexHeroHeading {
    color: #fff;
    font-family: Roboto;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
  }
}

.clindexHeroTitel {
  color: #fff;
  font-family: "Roboto";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px;
}
@media only screen and (max-width: 767.98px) {
  .clindexHeroTitel {
    color: #fff;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 23px;
  }
}

.heroParagraph {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #ffffff;
  margin-top: 30px;
  width: 100%; /* Set width to 100% for all screen sizes */

  /* Media query for screens smaller than or equal to 767.98px */
}

@media only screen and (max-width: 767.98px) {
  .heroParagraph {
    width: 67%;
    color: #fff;
    font-family: "Roboto";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
  }
}

@media only screen and (max-width: 767.98px) {
  /* For screens smaller than medium (up to 767.98px) */
  .heroWomanImageHomePage {
    /* Add your desired margin for smaller screens here */
    /* overflow: hidden; */
    margin-top: -49%;
    margin-left: auto;
    margin-right: -11.2px;
    width: 62%;
    height: auto;
    /* transform: scaleX(-1); */
  }

  /* .heoTextAea{
    
  } */
  .heroParagraph {
    /* z-index: 2;
  position: relative; */

    margin-right: 60px;
  }
  .buttonsRowHero {
    position: absolute;
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
}
/* styles.css */
@media (max-width: 768px) {
  .hideOnMobile {
    display: none;
  }
  .showOnMobile {
    display: block;
  }
}

.buttonsRowHero {
  margin-top: 50px;
}
@media only screen and (max-width: 767.98px) {
  .buttonsRowHero {
    margin-top: screen;
  }
}

.letsTalkButtonBox {
  width: 177px;
  height: 56px;
  border-radius: 4px;
  background: #548dff;
}
@media only screen and (max-width: 767.98px) {
  .letsTalkButtonBox {
    width: 160px;
    height: 40px;
    margin-left: 2%;
  }
}

.letsTalkCoustomText {
  color: #fff;
  text-align: center;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  padding-top: 17px;
}
@media only screen and (max-width: 767.98px) {
  .letsTalkCoustomText {
    padding-top: 9px;
  }
}

.learnButtonButtonBoxHero {
  width: 177px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid white;
  margin-left: 10px;
  padding-bottom: 53px;
}
@media only screen and (max-width: 767.98px) {
  .learnButtonButtonBoxHero {
    width: 160px;
    height: 40px !important;
    padding-bottom: 12px;
    margin-left: auto;
    margin-right: auto;
  }
}

.learnButtonCoustomTextHero {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  padding-top: 16px;
  color: white;
}
@media only screen and (max-width: 767.98px) {
  .learnButtonCoustomTextHero {
    padding-top: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/HRManagement/components/Hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,qDAAqD;EACrD;IACE,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,+BAA+B;EACjC;EACA,qDAAqD;EACrD;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW,EAAE,2CAA2C;;EAExD,8DAA8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,qDAAqD;EACrD;IACE,qDAAqD;IACrD,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;;KAEG;EACH;IACE;uBACmB;;IAEnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,UAAU;EACZ;AACF;AACA,eAAe;AACf;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".coustomBg {\n  background: #c4c4c4;\n  height: 737px;\n  clip-path: circle(180vh at 50% -80vh);\n  position: relative;\n}\n.imageContainer {\n  position: absolute;\n  right: 0%;\n  bottom: 0;\n  width: 35%;\n}\n.heroWomanImage {\n  width: 80%;\n}\n@media only screen and (max-width: 767.98px) {\n  /* For screens smaller than medium (up to 767.98px) */\n  .coustomBg {\n    height: 500px;\n    border-bottom-left-radius: 140px 100px;\n    position: relative;\n    overflow: hidden;\n    padding-top: 24px;\n  }\n}\n\n.bookingBackgroundCoustom {\n  width: 213px;\n  height: 31px;\n  background-color: white;\n  line-height: 33px;\n  margin-top: 80px;\n}\n@media only screen and (max-width: 767.98px) {\n  .imageContainer {\n    position: absolute;\n    width: 60%;\n    left: 42%;\n    bottom: 0;\n    transform: scaleX(1) !important;\n  }\n  /* For screens smaller than medium (up to 767.98px) */\n  .heroWomanImage {\n    width: 100%;\n    height: auto;\n  }\n  .bookingBackgroundCoustom {\n    width: 200px;\n    height: 30.706px;\n    color: #fff;\n    font-family: \"Roboto\";\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 33px;\n    margin-top: 20px;\n  }\n}\n.bookingText {\n  color: #5b7cfd;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  margin-left: 5px;\n}\n.clindexHeroHeading {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 50px;\n  color: #ffffff;\n}\n@media only screen and (max-width: 767.98px) {\n  .clindexHeroHeading {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 50px;\n  }\n}\n\n.clindexHeroTitel {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 50px;\n}\n@media only screen and (max-width: 767.98px) {\n  .clindexHeroTitel {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23px;\n  }\n}\n\n.heroParagraph {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #ffffff;\n  margin-top: 30px;\n  width: 100%; /* Set width to 100% for all screen sizes */\n\n  /* Media query for screens smaller than or equal to 767.98px */\n}\n\n@media only screen and (max-width: 767.98px) {\n  .heroParagraph {\n    width: 67%;\n    color: #fff;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n  }\n}\n\n@media only screen and (max-width: 767.98px) {\n  /* For screens smaller than medium (up to 767.98px) */\n  .heroWomanImageHomePage {\n    /* Add your desired margin for smaller screens here */\n    /* overflow: hidden; */\n    margin-top: -49%;\n    margin-left: auto;\n    margin-right: -11.2px;\n    width: 62%;\n    height: auto;\n    /* transform: scaleX(-1); */\n  }\n\n  /* .heoTextAea{\n    \n  } */\n  .heroParagraph {\n    /* z-index: 2;\n  position: relative; */\n\n    margin-right: 60px;\n  }\n  .buttonsRowHero {\n    position: absolute;\n    position: absolute;\n    bottom: 10%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 2;\n  }\n}\n/* styles.css */\n@media (max-width: 768px) {\n  .hideOnMobile {\n    display: none;\n  }\n  .showOnMobile {\n    display: block;\n  }\n}\n\n.buttonsRowHero {\n  margin-top: 50px;\n}\n@media only screen and (max-width: 767.98px) {\n  .buttonsRowHero {\n    margin-top: screen;\n  }\n}\n\n.letsTalkButtonBox {\n  width: 177px;\n  height: 56px;\n  border-radius: 4px;\n  background: #548dff;\n}\n@media only screen and (max-width: 767.98px) {\n  .letsTalkButtonBox {\n    width: 160px;\n    height: 40px;\n    margin-left: 2%;\n  }\n}\n\n.letsTalkCoustomText {\n  color: #fff;\n  text-align: center;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  padding-top: 17px;\n}\n@media only screen and (max-width: 767.98px) {\n  .letsTalkCoustomText {\n    padding-top: 9px;\n  }\n}\n\n.learnButtonButtonBoxHero {\n  width: 177px;\n  height: 56px;\n  border-radius: 4px;\n  border: 1px solid white;\n  margin-left: 10px;\n  padding-bottom: 53px;\n}\n@media only screen and (max-width: 767.98px) {\n  .learnButtonButtonBoxHero {\n    width: 160px;\n    height: 40px !important;\n    padding-bottom: 12px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.learnButtonCoustomTextHero {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  padding-top: 16px;\n  color: white;\n}\n@media only screen and (max-width: 767.98px) {\n  .learnButtonCoustomTextHero {\n    padding-top: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
